import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const ControlTowerPage = lazy(() => import('@cobliteam/routing/src/pages/ControlTower/ControlTower'));
const RoutingPage = lazy(() => import('@cobliteam/routing/src/router'));
const RouteEditPage = lazy(() => import('@cobliteam/routing/src/components/RouteEditPage'));
const ActivityEditPage = lazy(() => import('@cobliteam/routing/src/pages/ActivityEditPage'));
const RoutingContainer = lazy(() => import('@cobliteam/routing/src/containers/Routing/RoutingContainer'));

const routes = [
  {
    path: Location.ROUTING,
    component: RoutingPage,
    accessDeniedDescription: 'criar novas rotas',
    exact: false,
    routes: [
      {
        path: Location.ROUTING,
        component: ControlTowerPage,
        accessDeniedDescription: 'criar novas rotas',
        exact: true,
      },
      {
        path: Location.ROUTING_ACTIVITIES,
        component: ControlTowerPage,
        accessDeniedDescription: 'criar novas rotas',
        exact: true,
      },
      {
        path: Location.ROUTING_ROUTES,
        component: ControlTowerPage,
        accessDeniedDescription: 'criar novas rotas',
        exact: true,
      },
      {
        path: Location.ROUTING_PLANNING,
        component: RoutingContainer,
        accessDeniedDescription: 'criar novas rotas',
        exact: true,
      },
      {
        path: Location.ROUTING_EDIT,
        component: RouteEditPage,
        accessDeniedDescription: 'editar rotas em andamento',
        exact: true,
      },
      {
        path: Location.ROUTING_ACTIVITY_EDIT,
        component: ActivityEditPage,
        accessDeniedDescription: 'editar rotas em andamento',
        exact: true,
      },
    ],
  },
];

export default routes;
